import * as angular from 'angular';
import { ComponentsModule } from '~/core-app/components';
import { SharedServicesModule } from '~/modules/mode-shared-services';
import { SharedUiModule } from '~/modules/shared-ui/shared-ui.module';
import { BigValuesEncodingBuilderComponent } from './encoding-builder-big-values.component';
import { FilterEncodingBuilderComponent } from './encoding-builder-filter.component';
import { TableEncodingBuilderComponent } from './encoding-builder-table.component';
import { EncodingBuilderComponent } from './encoding-builder.component';
import { FilterFieldComponent } from './filter-field.component';
import { TableFieldComponent } from './table-field.component';
import { ViewCalcFieldComponent } from './view-calc-field.component';
import { ColorPaletteAssignmentComponent } from '@mode/charts/feature-encoding';
import { downgradeComponent } from '@angular/upgrade/static';

export const EncodingBuilderModule = angular
  .module('encoding-builder', [ComponentsModule, SharedUiModule, SharedServicesModule])
  .component('encodingBuilder', EncodingBuilderComponent)
  .component('filterEncodingBuilder', FilterEncodingBuilderComponent)
  .component('tableEncodingBuilder', TableEncodingBuilderComponent)
  .component('tableField', TableFieldComponent)
  .component('encViewCalcField', ViewCalcFieldComponent)
  .component('bigValuesEncodingBuilder', BigValuesEncodingBuilderComponent)
  .directive('modeColorPaletteAssignment', downgradeComponent({ component: ColorPaletteAssignmentComponent }))
  .component('encFilterField', FilterFieldComponent).name;
